import { Dispatch, useCallback, useEffect, useState } from "react";
import { UnknownAction } from "@reduxjs/toolkit";
import { setPreviousPath } from "./appSlice";

const useLocationTracker = ({ dispatch }: { dispatch: Dispatch<UnknownAction> }) => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  const listener = useCallback(() => {
    if (window.location.pathname === currentPath) {
      return;
    }
    dispatch(setPreviousPath(currentPath));
    setCurrentPath(window.location.pathname);
  }, [currentPath, dispatch]);

  useEffect(() => {
    // Listen to browser back/forward buttons
    window.addEventListener("popstate", listener);
    // Intercept programmatic navigation (React Router uses these)
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args);
      listener();
    };
    window.history.replaceState = function (...args) {
      originalReplaceState.apply(window.history, args);
      listener();
    };
    return () => {
      window.removeEventListener("popstate", listener);
      // Restore original methods to prevent infinite wrapper chain memory leak
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [listener]);
};

export default useLocationTracker;
